import { render, staticRenderFns } from "./GoodsListBlock.vue?vue&type=template&id=28125163&scoped=true"
import script from "./GoodsListBlock.vue?vue&type=script&lang=js"
export * from "./GoodsListBlock.vue?vue&type=script&lang=js"
import style0 from "./GoodsListBlock.vue?vue&type=style&index=0&id=28125163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28125163",
  null
  
)

export default component.exports